import { Col, Label, ReactSelectBox } from "client/CommonComponents";

const Trailer = (props?: any) => {
 const managedEquipmentValues = props?.managedEquipmentValues;
 const manufacturerDropDownList = props?.manufacturerDropDownList;
 const StyleDropDownList = props?.StyleDropDownList;
 const lengthDropDownList =props?.lengthDropDownList;
 const fuelTankDropDownList = props?.fuelTankDropDownList;
 const chargingStationDropdownList = props?.chargingStationDropdownList;
 const managedEquipRef = props?.managedEquipRef;
 const handleManufacturerChange =props?.handleManufacturerChange;
 const handleStyleChange = props?.handleStyleChange;
 const handleLengthChange = props?.handleLengthChange;
 const handleFuelTankChange = props?.handleFuelTankChange;
 const handleChargingStationChange =props?.handleChargingStationChange;

  return (<>
     <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="Trailer_Default_Label">Manufacturer</Label>
        <ReactSelectBox
          options={manufacturerDropDownList}
          onChange={(item: any, e: any) => handleManufacturerChange(e, item,'manufacturer')}
          value={managedEquipmentValues?.manufacturer}
          selectRef={(element:any)=> managedEquipRef.current[1] = element}
         data-attribute="Trailer_Default_SearchSelectBox" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="Trailer_Default_Label_2">Style</Label>
        <ReactSelectBox
          options={StyleDropDownList}
          onChange={(item: any, e: any) => handleStyleChange(e, item,'style')}
          value={managedEquipmentValues?.style}
          selectRef={(element:any)=> managedEquipRef.current[2] = element}

         data-attribute="Trailer_Default_SearchSelectBox_2" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="Trailer_Default_Label_3">Length</Label>
          <ReactSelectBox
            options={lengthDropDownList}
            onChange={(item: any, e: any) => handleLengthChange(e, item,'length')}
            value={managedEquipmentValues?.length}
            selectRef={(element:any)=> managedEquipRef.current[3] = element}
           data-attribute="Trailer_Default_SearchSelectBox_3" />
        </Col>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="Trailer_Default_Label_4">Fuel-Tank</Label>
          <ReactSelectBox
            options={fuelTankDropDownList}
            onChange={(item: any, e: any) => handleFuelTankChange(e, item,'fuelTank')}
            value={managedEquipmentValues?.fuelTank}
            selectRef={(element:any)=> managedEquipRef.current[4] = element}

           data-attribute="Trailer_Default_SearchSelectBox_4" />
        </Col>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="Trailer_Default_Label_5">Charging Station</Label>
          <ReactSelectBox
            options={chargingStationDropdownList}
            onChange={(item: any, e: any) => handleChargingStationChange(e, item,'chargingStation')}
            value={managedEquipmentValues?.chargingStation}
            selectRef={(element:any)=> managedEquipRef.current[5] = element}
           data-attribute="Trailer_Default_SearchSelectBox_5" />
        </Col>    
  </>)
}

export default Trailer;
